import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ArticleUtils } from '@article/util/article-utils';
import { Log } from '@shared/debug/log';
import { ModalComponent } from '@shared/modal/modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleVO } from '@article/model/vo/article.vo';
import { SystemConfigurationService } from '../../system-configuration/system-configuration-loading.service';

type OpenType = 'ltl-wizard' | 'configuration' | undefined;

@Component({
  selector: 'app-redirect-after-adding-invalid-article',
  templateUrl: './redirect-after-adding-invalid-article.component.html',
  imports: [
    TranslateModule,
    ModalComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectAfterAddingInvalidArticleComponent implements OnInit {
  private readonly bsModalRef = inject(BsModalRef);
  private readonly systemConfigurationService = inject(SystemConfigurationService);

  public articleVO!: ArticleVO;
  public openType = signal<OpenType>(undefined);
  public message = signal<string>('');

  public ngOnInit(): void {
    const isLtl = ArticleUtils.isLtlArticle(this.articleVO);
    this.openType.set(isLtl ? 'ltl-wizard' : 'configuration');
  }

  public submit(): void {
    if (!Log.assertExists(this.articleVO)) {
      return;
    }

    if(this.openType() == 'ltl-wizard') {
      window.open('/wizard/ltl', '_blank');
      this.close();
      return;
    }

    const newURL: string =
      this.systemConfigurationService.currentConfiguration.url +
      'html/#/' + // add 'html/#/' while url is http://.../wago
      this.systemConfigurationService.currentConfiguration.mainPage +
      '?function=createproject&articleids=' +
      this.articleVO.articleNo;
    window.open(newURL, '_blank');
    this.close();
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
